import { ref } from 'firebase/database';
import { Teacher } from '@opanuj/shared/types';
import { teachersCreate } from '../operations/admin/teachersCreate';
import { teachersDelete } from '../operations/admin/teachersDelete';
import { teachersSubjectsUpdate } from '../operations/admin/teachersSubjectsUpdate';
import { teachersUpdate } from '../operations/admin/teachersUpdate';
import { useCallback } from 'react';
import { useDatabase } from './useDatabase';
import { useListKeys, useListVals, useObjectVal } from 'react-firebase-hooks/database';
import { withDefaultList, withDefaultObject } from './defaults';

export const useTeachers = () => {
	const database = useDatabase();
	const [teachers, loading, error] = useObjectVal<{ [name: string]: Teacher }>(ref(database, 'teachers'));
	return [withDefaultObject(teachers), loading, error] as const;
}

export const useTeachersList = () => {
	const database = useDatabase();
	const [teachers, loading, error] = useListVals<Teacher>(ref(database, 'teachers'));
	return [withDefaultList(teachers), loading, error] as const;
}

export const useTeachersListKeys = () => {
	const database = useDatabase();
	return useListKeys(ref(database, 'teachers'));
}

export const useTeachersCreate = () => {
	const database = useDatabase();
	return useCallback((teacherName: string, subjects: string[] = []) => teachersCreate(database, teacherName, subjects), [database]);
};

export const useTeachersDelete = () => {
	const database = useDatabase();
	return useCallback((teacherName: string) => teachersDelete(database, teacherName), [database]);
};

export const useTeachersUpdate = () => {
	const database = useDatabase();
	return useCallback(
		(previousTeacherName: string, nextTeacherName: string, teacher: { name?: string; subjects?: string[]; [key: string]: unknown }) =>
			teachersUpdate(database, previousTeacherName, nextTeacherName, teacher),
		[database]
	);
};

export const useTeachersSubjectsUpdate = () => {
	const database = useDatabase();
	return useCallback((teacherName: string, subjects: string[]) => teachersSubjectsUpdate(database, teacherName, subjects), [database]);
};